<div class="relative project-cover-wrap" [class.featured]="featured">
  <ng-container *ngIf="project?.private && !self; else defaultView">
    <div (click)="openPrivatePopup()">
      <ng-container *ngTemplateOutlet="contentView">
      </ng-container>
    </div>
  </ng-container>
  <ng-template #defaultView>
    <a [href]="getProjectDetailLink()" class="cursor-pointer">
      <ng-container *ngTemplateOutlet="contentView">
      </ng-container>
    </a>
  </ng-template>
  <ng-template #contentView>
    <uni-image
      [src]="project.content?.cover?.media?.url"
      [alt]="project.content.title"
      [width]="720"
      [height]="369"
      classes="margin-0 padding-0 rounded-bottom-border absolute 
              top-0 left-0 sparro-bg-grey-200 fit-cover height-100 width-100">
    </uni-image>
  </ng-template>

  <div class="absolute bottom-3 left-3" *ngIf="project.trophies && showTrophyBadge">
    <ng-container *ngFor="let trophy of project.trophies">
      <div class="project-badge hover-expand padding-0 margin-top-2">
        <i class="icon-award font-sm fx-contents badge-icon"></i>
        <span class="hidden-child font-xxs badge-text">{{trophy}}</span>
      </div>
    </ng-container>
  </div>
  <div
    class="absolute bottom-3 right-3"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    *ngIf="showGeneralBadges">
    <div fxLayoutAlign="start center" fxLayoutGap="8px">
      <div
        class="project-badge"
        *ngIf="project.private">
        <i class="icon-block font-sm fx-contents sparro-red-600"></i>
        <!-- <span class="hidden-child font-xxs sparro-red-600">Private</span> -->
      </div>
      <div
        class="project-badge"
        *ngIf="project.likes">
        <i class="icon-like font-sm fx-contents badge-icon"></i>
        <span class="font-xxs badge-text">{{ project.likes }}</span>
      </div>
      <div
        class="project-badge"
        *ngIf="project.comments">
        <i class="icon-comments font-sm fx-contents badge-icon"></i>
        <span class="font-xxs badge-text">{{ project.comments }}</span>
      </div>
    </div>
  </div>
</div>
